import React, { useState } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomeScreen from './HomeScreen';
import RecipesList from './RecipesList';
import RecipeProfile from './RecipeProfile';
import RecipeAdd from './RecipeAdd';
import RecipeDetails from './RecipeDetails';
import AdvancedSearch from './AdvancedSearch';
import ContentCreatorRecipes from './ContentCreatorRecipes';
import PrivacyPolicy from './PrivacyPolicy';
import TermsOfService from './TermsOfService';
import ContactSupport from './ContactSupport';
import CreatorsScreen from './CreatorsScreen';
import CreatorLogin from './CreatorLogin';
import CreatorDashboard from './CreatorDashboard';
import Header from './components/Header';
import Analytics from './components/Analytics';
import ScrollToTop from './components/ScrollToTop';
import AppDownloadPopup from './components/AppDownloadPopup';
import Clarity from '@microsoft/clarity';

const projectId = "r4972i51uz"
Clarity.init(projectId);

function App() {
  const [searchQuery, setSearchQuery] = useState('');

  return (
    <Router>
      <div style={{ overflowX: 'hidden' }}>
        <ScrollToTop />
        <Analytics />
        <AppDownloadPopup />
        <Header searchQuery={searchQuery} setSearchQuery={setSearchQuery} />
        <Routes>
          <Route path="/" element={
            <RecipesList 
              searchQuery={searchQuery} 
              setSearchQuery={setSearchQuery}
            />
          } />
          <Route path="/home" element={<HomeScreen />} />
          <Route path="/recipes-profile" element={<RecipeProfile />} />
          <Route path="/recipe-add" element={<RecipeAdd />} />
          <Route path="/recipe-add/:id" element={<RecipeAdd />} />
          <Route path="/recipe-details/:id" element={<RecipeDetails />} />
          <Route path="/advanced-search" element={<AdvancedSearch />} />
          <Route path="/content-creator/:id" element={<ContentCreatorRecipes />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/support" element={<ContactSupport />} />
          <Route path="/creators" element={<CreatorsScreen />} />
          <Route path="/creators/login" element={<CreatorLogin />} />
          <Route path="/creators/dashboard" element={<CreatorDashboard />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;

